import React from 'react';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import 'moment/locale/es';
import GuardiaPositionPrompt from '../components/GuardiaPositionPrompt';
import './OperacionInicio.css';

moment.locale('es');

function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const OperacionInicio = () => {
  const token = useSelector((state) => state.auth.token);

  let stationName = '';
  try {
    if (token) {
      const decoded = jwtDecode(token);
      stationName = decoded.estacion || decoded.station || decoded.sub || '';
    }
  } catch (_) {}

  const todayFormatted = capitalize(moment().format('dddd D [de] MMMM [de] YYYY'));
  const greeting = (() => {
    const h = moment().hour();
    if (h < 12) return 'Buenos días';
    if (h < 19) return 'Buenas tardes';
    return 'Buenas noches';
  })();

  return (
    <div className="oi-container">
      <div className="oi-content">
        <div className="oi-welcome">
          <h1 className="oi-title">{greeting}</h1>
          <p className="oi-subtitle">
            {stationName ? `${stationName} — ` : ''}{todayFormatted}
          </p>
        </div>
        <div className="oi-brand">
          <span className="oi-brand-name">MINTAKA</span>
          <span className="oi-brand-sub">Panel de Coordinación</span>
        </div>

        <GuardiaPositionPrompt />
      </div>
    </div>
  );
};

export default OperacionInicio;
